import { addIntersectionItem } from '../../02-tools'

let stickyBtn
let isFixed = false

export function StickyBtn() {
    stickyBtn = document.querySelector('.c-overview a[href="#form"]')

    if (!stickyBtn) {
        return
    }

    addIntersectionItem(stickyBtn.parentElement, handleIntersection)
}

function handleIntersection(_, entry) {
    if (entry.boundingClientRect.y <= 0 && !isFixed) {
        stickyBtn.classList.add('is-fixed')
        isFixed = true
    } else if (entry.boundingClientRect.y > 0 && isFixed) {
        stickyBtn.classList.remove('is-fixed')
        isFixed = false
    }
}
